import { ObjectHelper } from '../../../../../../apps/idl/src/helpers/objectHelper';

export class PermissionMissingError extends Error {
	constructor(psMessage: string) {
		super(psMessage);
		// Nécessaire pour que le 'instanceof PermissionMissingError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, PermissionMissingError);
	}

}